module.exports = __webpack_public_path__ + "img/ddos.0bd8d43.webp";